import React from 'react';

import { LessonPreviewLayout } from 'components/Layout';

import { WebPreviewPage } from './components/WebPreviewPage';
import { PluginPreviewPage } from './components/PluginPreviewPage';

const DifferenceLessonPreviewPage = ({
  submitted,
  currentAnswer,
  currentCompareAnswer,
  lesson,
  onAnswerClick,
  onRestartLessonClick,
  previewType,
  setPreviewType,
  isTestMode,
  setTestMode,
  ...props
}: {
  submitted: any;
  currentAnswer: any;
  currentCompareAnswer: any;
  lesson: any;
  onAnswerClick: any;
  onRestartLessonClick: any;
  previewType: any;
  setPreviewType: any;
  isTestMode: any;
  setTestMode: any;
  props: any;
}) => (
  <LessonPreviewLayout
    setPreviewType={setPreviewType}
    setTestMode={setTestMode}
  >
    {previewType === 'Plugin' ? (
      <PluginPreviewPage
        {...props}
        submitted={submitted}
        lesson={lesson}
        currentAnswer={currentAnswer}
        currentCompareAnswer={currentCompareAnswer}
        onAnswerClick={onAnswerClick}
        onRestartLessonClick={onRestartLessonClick}
        isTestMode={isTestMode}
        previewType={previewType}
      />
    ) : (
      <WebPreviewPage
        {...props}
        submitted={submitted}
        lesson={lesson}
        currentAnswer={currentAnswer}
        currentCompareAnswer={currentCompareAnswer}
        onAnswerClick={onAnswerClick}
        onRestartLessonClick={onRestartLessonClick}
        isTestMode={isTestMode}
      />
    )}
  </LessonPreviewLayout>
);

export default React.memo(DifferenceLessonPreviewPage) as any;
